import { thunks } from 'services/thunks';

export const block = store => () => {
  console.log('block');
  store.dispatch(thunks.logout({ isBlocked: true }));
};
